<template>
  <div>
    <Breadcrumb :title="`Buyout Detail: ${PartnerName}`"></Breadcrumb>
      <div class="form-row">
        <div class="form-group col-md-12">
          <label class="section-title" style="margin:0px;padding:0px;!important">Termination Date : {{displayFields.TerminationDate}}</label><br>
        </div>
      </div>
    <BaseSearchBar :config="SearchBuyout" @keyupSearch="filterGrid"></BaseSearchBar>
    <BaseToolBar :config="BuyoutDetailToolBarConfig" @buttonClicked="BuyoutDetailToolBarClick"></BaseToolBar>
    <BaseGrid :mode="'editform'" :excelExport="excelExport" :config="ProgramDetailGridConfig" :data="ProgramDetailGridData"
     ></BaseGrid>

    <!-- <BuyoutDocumentDropoffForm
      ref="buyoutDocument"
      :docModalConfig="docModalConfig"
      :filterCondition="filterCondition"
      :transactionRecord="selectedBuyout"
    ></BuyoutDocumentDropoffForm> -->
  </div>
</template>

<script>
// Breadcrumb implementation
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import $ from "jquery";
import moment from "moment";

// Base Searchbar Implementation
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import funcUtil from "@/services/funcUtil.js";

// Base Toolbar Implementation
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import {
  ProgramDetailGridConfig,
  BuyoutDetailToolBarConfig
} from "./BuyoutReportConfig.js";

import BaseModelBuyout from "@/models/BaseModelBuyout.js";
import BaseModelVestingSchedule from "@/models/BaseModelVestingSchedule.js";
import BaseModelPartner from "@/models/BaseModelPartner.js";

// Base Grid Implementation
import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";
import _ from "lodash";
import { mapGetters } from "vuex";
//import BuyoutDocumentDropoffForm from "@/components/forms/BuyoutDocumentDropoffForm.vue";

export default {
  name: "BuyoutReportDetail",
  mixins: [apiUtil, funcUtil, toolbarUtility],
  components: {
    Breadcrumb,
    BaseSearchBar,
    BaseToolBar,
    BaseGrid,
    //BuyoutDocumentDropoffForm
  },

  data: function() {
    return {
      // Base Grid implementation
      gridId: ProgramDetailGridConfig.grid.gridId,
      partnerId: this.$route.params.partnerId,
      PartnerName: "",
      ProgramDetailGridConfig: ProgramDetailGridConfig,
      BuyoutDetailMasterData: [],

      // Base Toolbar Implementation
      BuyoutDetailToolBarConfig: BuyoutDetailToolBarConfig,

      // Base Searchbar implementation
      SearchBuyout: {
        SearchData: ""
      },

      ProgramDetailGridData: [],
      BaseModelBuyout: BaseModelBuyout,
      BaseModelVestingSchedule : BaseModelVestingSchedule,
      BaseModelPartner : BaseModelPartner,
      // Document dropoff modal
      docModalConfig: {
        modalName: "Buyout Documents",
        modalIdandRef: "docModal",
        isFooter: false
      },
      // Filter condition for Document dropoff modal
      filterCondition: {
        filter: "",
        limit: 500
      },
      selectedBuyout:{},
      displayFields: {
        TerminationDate: ""
      },
    };
  },

  computed: {
    ...mapGetters("getModule", ["withFilter", "getAllItemFilter","GetValueByKey"])
  },

  beforeRouteUpdate(to, from, next) {
    this.partnerId = to.params.partnerId;
    if (this.partnerId) {
    } else {
    }
    next();
  },

  mounted() {
    const self = this;
    // Tool bar grid setting
    // self._loadGridSettings(self.gridId);
    self.displayFields.TerminationDate = self.GetValueByKey("BuyoutTerminationDate");
    if(self.displayFields.TerminationDate!='')
    {
      let date = new Date(self.displayFields.TerminationDate);
      self.displayFields.TerminationDate= moment(String(date.toISOString())).format('MM/DD/YYYY')
    }
    else
    {
     self.backtoPartner(); 
    }
    
    //Bind databound event to grid
    var grid = $("#reportBuyoutProgramGrid").data("kendoGrid");
    grid.bind("dataBound", self.UpdateBuyoutDetailMasterData);

    self.getBaseGridData();
  },

  methods: {

    async getBaseGridData() {
      const self = this;
      await self.getProgramGridData();
      console.log("self.gridId",self.gridId);
      self._loadGridSettings(self.gridId);
    },

    backtoPartner: function() {
      this.$router.push("/report/buyout");
    },

    UpdateBuyoutDetailMasterData: function(fromFilter, filterMasterData) {
      const self = this;
      if (fromFilter == true) {
        self.BuyoutDetailMasterData = filterMasterData;
      } else {
        self.BuyoutDetailMasterData = $("#reportBuyoutProgramGrid")
          .data()
          .kendoGrid.dataSource.data();
      }
    },

    // Grid search
    filterGrid: function() {
      const self = this;
      const currentMasterdata = self.BuyoutDetailMasterData;

      let filteredData = self._filterGrid(
        self.BuyoutDetailMasterData,
        self.SearchBuyout.SearchData
      );

      $("#reportBuyoutProgramGrid")
        .data("kendoGrid")
        .dataSource.data(filteredData);
      self.UpdateBuyoutDetailMasterData(true, currentMasterdata);
    },

    // Toolbar Submit Forfeiture butt, Generate Document
    BuyoutDetailToolBarClick(e) {
      const self = this;
      e.preventDefault();
      if (e.id === "btnBack") {
        self.backtoPartner();
      }
      //console.log("self.ProgramDetailGridData",self.ProgramDetailGridData);

      let partnerQuery = {
        filter: "Id eq " + self.partnerId
      };

      let partnerInfo = self.withFilter(self.BaseModelPartner.list, partnerQuery)[0];
      console.log("partnerInto",partnerInfo);
      var TSDocSplitLength=partnerInfo.TSDocId.toString().split('-').length;
      var ssn=partnerInfo.TSDocId.toString().split('-')[TSDocSplitLength-1]
      var hireDate = moment(partnerInfo.HireDate).format("MM/DD/YYYY") ? moment(partnerInfo.HireDate).format("MM/DD/YYYY") : "N/A"
      var headerList=[
        {id:"Employee name", value:partnerInfo.FullName},
        {id:"Hire Date", value:moment(partnerInfo.HireDate).format("MM/DD/YYYY")},
        {id:"Termination Date", value:moment(partnerInfo.LeaveDate).format("MM/DD/YYYY")},
        //{id:"As Of", value:kendo.toString(new Date, "MM/dd/yyyy")},
        {id:"Report Generated On", value: moment(this.selectedDate).format("MM/DD/YYYY")}
      ]
      var fileName = ssn+"_"+partnerInfo.FullName+"_Buyout Report.xlsx";
      var arguementList={
        ...arguments,
        fileName:fileName,
        headers:headerList
      }

      self._baseToolBarEvents(self.gridId, arguementList);
    },

    refreshGrid: function() {
      this.getProgramGridData();
    },

    async getProgramGridData() {
      const self = this;
      self.ProgramDetailGridData = [];

      let partnerQuery = {
        filter: "PartnerId eq " + self.partnerId
      };

      let partnerInfo;

      let response = await this.withFilter(self.BaseModelBuyout.list, partnerQuery);
      console.log("buyout response",response);
      // let buyoutData = _.filter(response.Buyout, function(obj) {
      //   return obj.PartnerId == self.partnerId;
      // });

      if (response.length > 0) {
        response.forEach( async item => {
          console.log("item",item);
          let special = await self.getSpecialVesting(item);
          item.SpecialArrangement = special ? "Yes" : "No";
          console.log(typeof(item.SpecialArrangement),typeof(item.Status),special);
        })
        console.log("sa",response);
        self.PartnerName = await response[0].PartnerFullName;
        self.ProgramDetailGridData = await response;
      }

      // console.log(self.ProgramDetailGridData);
    },

    async getSpecialVesting(Program) {
      let self = this;
      console.log("Program",Program);
      let partnerQuery = {
        filter: "Id eq " + self.partnerId
      };
      let vestingQuery = {
        filter : "ProgramId eq " + JSON.stringify(Program.ProgramId) + " and UnitClass eq "+"'"+Program.UnitClass +"'"
      }
      let partnerDetail = await self.withFilter(self.BaseModelPartner.list,partnerQuery);
      let vestingScheduleData = await self.withFilter(self.BaseModelVestingSchedule.list,vestingQuery);

      let startDate, special = "";
      vestingScheduleData.forEach(async item => {
        if(item.Year == 0 && item.VestingType == Program.VestingType) {
          startDate = moment(partnerDetail.HireDate) > moment(item.VestDate) ? moment(partnerDetail.HireDate) : moment(item.VestDate);
          if(startDate) {
            let year4 = moment(startDate).add(5,"Year");
            special = moment(partnerDetail.LeaveDate) >= moment(year4) ? 0 : 1;
          }
        }
      })

      console.log("partner info",partnerDetail,vestingScheduleData,special);
      //console.log(Program.ProgramId, self.partnerId);
      return special;

    }
    // Buyout Documnet Dropoff
    // BuyoutAttachment: function(e) {
    //   let self = this;
    //   e.preventDefault();
    //   const gview = window.$("#reportBuyoutProgramGrid").data("kendoGrid");
    //   const dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));

    //   this.selectedBuyout={...dataItem};

    //   this.selectedBuyout.PartnerTitle=dataItem.PartnerFullName,
    //   this.selectedBuyout.PartnerId=dataItem.PartnerId
    //   this.selectedBuyout.ProgramTitle=dataItem.ProgramTitle
    //   this.selectedBuyout.ProgramId=dataItem.ProgramId
    //   this.selectedBuyout.TransactionID=dataItem.Id
    //   this.selectedBuyout.BusinessEvent="Buyout"

    //   this.filterCondition.filter = `BusinessEvent eq 'Buyout' and TransactionID eq ${
    //     dataItem.Id
    //   }`;

    //   this.$refs.buyoutDocument.$refs.buyoutDocumentMgr.resetDropZoneGrid();
    //   window.$("#docModal").modal("toggle");
    // }
  }
};
</script>
